import { SelectableListKeyboardNavigationGroupHorizontal } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  selectedAttendees: server.dto.ContactSmallV2[]
  potentialAttendees: server.dto.ContactSmallV2[]

  onAttendeeSelected: (attendee: server.dto.ContactSmallV2) => void
}

const PotentialAttendees = (props: Props) => {
  const attendeesToShow = props.potentialAttendees
    .filter(a => !props.selectedAttendees.some(b => b.contactId === a.contactId));

  if (attendeesToShow.length === 0) {
    return <div></div>;
  }

  return <div className="flex-column gap-small">
    <div className="s1_gray">
      {RESX.Planning.ConsiderIncluding}:
    </div>

    <div>
      {attendeesToShow.map((a, idx) => (
        <React.Fragment key={a.contactId}>
          <a tabIndex={0} {...SelectableListKeyboardNavigationGroupHorizontal("potentialAttendees")} onClick={() => { props.onAttendeeSelected(a); }} style={{ whiteSpace: "nowrap" }}>
            {a.name.fullName}
          </a>
          {idx < attendeesToShow.length - 1 && <>, </>}
        </React.Fragment>
      ))}</div>
  </div>;
};

export default PotentialAttendees;